export default __webpack_public_path__ + "static/media/epc_logo.89dd170c.png";